import React from "react";
import { t } from "i18next";
import { motion } from "framer-motion";
import { QRCodeSVG } from "qrcode.react";
import { PiXBold } from "react-icons/pi";
import { Button } from "./ui/button";

import useMapStore from "@/store/mapStore";
import { cn, getMobileOperatingSystem } from "@/lib/utils";
import useNavigateToAmenity from "@/hooks/useNavigateToAmenity";

function InfoBox() {
  const mobileOS = getMobileOperatingSystem();
  const activeFilter = useMapStore((state) => state.activeFilter);
  const currentLang = useMapStore((state) => state.currentLang);
  const mobileMode = useMapStore((state) => state.mobileMode);
  const verticalKioskMode = useMapStore((state) => state.verticalKioskMode);

  const resetView = useMapStore((state) => state.resetView);

  const [navigateToFacility] = useNavigateToAmenity();

  const onCloseHandle = () => {
    console.log("close handler");
    resetView();
  };

  const customerServiceClick = () => {
    navigateToFacility({ amenityTitle: "customer-service-desk" });
  };

  let urlLink = "https://www.sharerewards.com/";

  if (mobileOS === "iOS") {
    urlLink = "https://apps.apple.com/ae/app/share-rewards/id1465450657";
  }

  if (mobileOS === "Android") {
    urlLink = "https://play.google.com/store/apps/details?id=com.maf.share";
  }

  return (
    <>
      <motion.div
        key="list"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0 }}
        transition={{ duration: 0.2 }}
        className={cn(
          "flex h-full flex-col px-10",
          mobileMode && "fixed z-100 h-full w-full bg-white p-10",
          verticalKioskMode &&
            "fixed bottom-12 left-[calc(5dvw)] top-auto z-[101] h-auto min-h-[25%] w-[calc(90dvw)] rounded-2xl rounded-t-2xl bg-white p-6 shadow-[0px_1px_6px_3px_rgba(0,0,0,0.5)]",
        )}
      >
        <div className="mb-4 flex items-center">
          <h1 className="flex-1 text-2xl font-bold capitalize">
            {t(activeFilter.title)}
          </h1>
          <Button
            onClick={onCloseHandle}
            size="icon"
            variant="outline"
            className="h-12 w-12 justify-end border-0 bg-transparent text-4xl group-data-[dir=ltr]:-mr-2 group-data-[dir=rtl]:-ml-2"
          >
            <PiXBold />
          </Button>
        </div>
        {activeFilter.title !== "share" && (
          <React.Fragment>
            {React.createElement("div", {
              dangerouslySetInnerHTML: {
                __html:
                  typeof activeFilter.content === "string"
                    ? activeFilter.content
                    : activeFilter.content
                      ? activeFilter.content[currentLang]
                      : "",
              },
            })}
          </React.Fragment>
        )}
        {activeFilter.title === "share" && currentLang === "en" && (
          <div>
            <h3 className="mb-6 text-2xl font-bold">
              Get More At City Centre Mirdif
            </h3>
            <p className="mb-6">
              As a member of the SHARE rewards programme, you get cash back in
              points at all stores and restaurants in City Centre Mirdif and
              beyond. Join the SHARE programme now – it’s free and will only
              take you a few minutes.
            </p>
            {mobileMode ? (
              <a
                href={urlLink}
                target="_blank"
                className="text-lg font-semibold text-blue-700 hover:text-primary"
              >
                Join SHARE Rewards
              </a>
            ) : (
              <QRCodeSVG
                value="https://www.sharerewards.com/"
                className="shrink-0"
                size={96}
              />
            )}
          </div>
        )}
        {activeFilter.title === "share" && currentLang === "ar" && (
          <div>
            <h3 className="mb-6 text-2xl font-bold">
              احصلوا على المزيد في سيتي سنتر مردف
            </h3>
            <p className="mb-6">
              تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة
              نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج
              المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم
              لانضمامكم إليه سوى دقائق معدودة.
            </p>
            {mobileMode ? (
              <a
                href={urlLink}
                target="_blank"
                className="text-lg font-semibold text-blue-700 hover:text-primary"
              >
                سجلوا في تطبيق شير
              </a>
            ) : (
              <QRCodeSVG
                value="https://www.sharerewards.com/"
                className="shrink-0"
                size={96}
              />
            )}
          </div>
        )}
        {activeFilter.title === "wifi" && (
          <>
            {currentLang === "en" && (
              <p>
                For any assistance, please visit the nearest{" "}
                <span
                  className="cursor-pointer text-primary"
                  onClick={customerServiceClick}
                >
                  Customer Service Help Desk.
                </span>
              </p>
            )}
            {currentLang === "ar" && (
              <p>
                للحصول على أي مساعدة، يرجى زيارة أقرب{" "}
                <span
                  className="cursor-pointer text-primary"
                  onClick={customerServiceClick}
                >
                  مكتب مساعدة لخدمة العملاء
                </span>
              </p>
            )}
            <p className="mb-10 mt-auto text-xs text-foreground/60 lg:mb-6">
              Version: {import.meta.env.VITE_WAYFINDING_VERSION}
            </p>
          </>
        )}
      </motion.div>
    </>
  );
}

export default InfoBox;
